import { render } from "./AppLayoutLinks.vue?vue&type=template&id=812cfc32&scoped=true"
import script from "./AppLayoutLinks.vue?vue&type=script&lang=js"
export * from "./AppLayoutLinks.vue?vue&type=script&lang=js"

import "./AppLayoutLinks.vue?vue&type=style&index=0&id=812cfc32&scoped=true&lang=css"

import exportComponent from "/home/tobias/code/github.com/RemondisDigitalServices/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812cfc32"]])

export default __exports__